<template>
  <div class="container containerManage mt10 ml10 mr10">
    <div class="handle-box mt10">
     
      <span class="fz14 c6">设备名称：</span>
      <el-input v-model.trim="query.name" placeholder="设备名称" class="handle-input mr10" style="width:160px"></el-input>
      <!-- <span class="fz14 c6 ml10 ">设备状态：</span>
      <el-select v-model="deviceStatus" clearable placeholder="请选择" style="width:160px">
          <el-option
          v-for="(item, index) in deviceList"
          :key="index+'c'"
          :label="item.dictValue"
          :value="item.dictKey">
          </el-option>
      </el-select> -->
       <span class="fz14 c6 ">设备型号：</span>
        <el-input v-model.trim="sawModelInput" clearable placeholder="设备型号" class="handle-input " style="width:160px"></el-input>

        <span class="fz14 c6 ml20 ">出厂编号：</span>
        <el-input v-model.trim="deviceNoInput" clearable placeholder="设备出厂编号" class="handle-input " style="width:160px"></el-input>
        <el-button type="primary" size="small" class="ml10" icon="el-icon-search" @click="getPage()">搜索</el-button>
       <el-button type="primary" size="small" class=" ml10" icon="el-icon-circle-plus-outline" @click="addHandle">添加设备</el-button>
       <el-button type="primary" size="small" class=" ml10"  @click="addexcel">导入设备</el-button>
      <div class="mt10">
        
        
        <!-- <span class="fz14 c6 ml20 ">经销商：</span>
        <el-select clearable v-model="dealer"  placeholder="请选择" style="width:160px">
            <el-option 
                v-for="item in dealerOptions"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
            ></el-option>
        </el-select> -->
        
</div>
     
      
      
      <!-- v-if="power_btn_add" -->
    </div>
    <div class="tableData">
      <el-table :data="tableData" border class="table"  style="width: 100%;" height="55vh" ref="multipleTable" header-cell-class-name="table-header">
        <el-table-column label="序号" width="60">
            <template slot-scope="scope">
               <div class="txtc">{{(query.pageIndex - 1) * query.pageSize + scope.$index + 1}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="gatewayName" label="设备名称" align="center"></el-table-column>
        <el-table-column prop="gatewayName" label="设备状态" align="center">
          <template slot-scope="scope">
               <span :class="`status status${scope.row.onlineFlag}`"></span>
            </template>
        </el-table-column>
        <el-table-column prop="alarmNum" label="报警数" align="center">
        
        </el-table-column>
        <el-table-column prop="deviceNo" label="设备出厂编号" min-width="140" align="center"></el-table-column>
        <el-table-column prop="sawModel" label="设备型号" align="center"></el-table-column>
        <!-- <el-table-column prop="gatewayName" label="报警数" min-width="140" align="center">
          <template slot-scope="scope">
               <div class="txtc"><span :class="`status staus${scope.row.deviceState}`"></span></div>
            </template>
        </el-table-column> -->
        <el-table-column prop="sn" label="网关SN" align="center"></el-table-column>
        <el-table-column prop="userName" label="联系人" align="center"></el-table-column>
        <el-table-column prop="userPhone" label="联系人号码" min-width="120" align="center"></el-table-column>
        <el-table-column prop="address" min-width="90" label="安装地点" align="center"></el-table-column>
        <el-table-column prop="installTime" min-width="150" label="安装时间" align="center"></el-table-column>
        <el-table-column  prop="status" label="状态" min-width="90" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">失败</span>
            <span v-if="scope.row.status == 1">成功</span>
            <span v-if="scope.row.status == 2">待处理</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-view" @click="viewHandle(scope.row)">详情</el-button>
            <el-button type="text" icon="el-icon-edit" @click="editHandle(scope.row)">编辑</el-button>
            <el-button type="text" icon="el-icon-delete" class="red" @click="deleteHandle(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    
    <div class="pagination txtr mt10">
      <el-pagination background layout="total, prev, pager, next" :current-page="query.pageIndex"
       :page-size="query.pageSize" :total="pageTotal" @current-change="handlePageChange"></el-pagination>
    </div>
    <!-- 添加或编辑弹出对话框 -->
    <el-dialog class="dialogBox" :title="dialogType" :visible.sync="DialogVisible" width="60%" :before-close='beforclose'  center>
      <el-form :model="form"  ref='form' class="flex ml20 mr20 c314" :rules="rules" >
        <p class="fz14">设备信息</p>
        <div class="mt10 boxDashed" >
          <div class="item_ flex center-row">
            <el-form-item class="_formItem" label="设备名称：" prop="gatewayName" :label-width="formLabelWidth">
              <el-input v-model="form.gatewayName" autocomplete="off" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item class="_formItem" label="出厂编号：" prop="deviceNo" :label-width="formLabelWidth">
              <el-input v-model="form.deviceNo" autocomplete="off" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item class="_formItem" label="网关类型：" prop="deviceModel" :label-width="formLabelWidth">
              <el-select v-model="form.deviceModel" placeholder="请选择"  :disabled="disabled">
                <el-option
                  v-for="(item,index) in typeList"
                  :key="index+'aa'"
                  :label="item.deviceModelName"
                  :value="item.deviceModel">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>
        <p class="fz14 mt20">网关信息</p>
        <div class="mt10 boxDashed" >
          <div class="item_ flex center-row">
          
            <el-form-item class="_formItem" label="网关SN：" prop="sn" :label-width="formLabelWidth">
              <el-input v-model="form.sn" autocomplete="off" :disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item class="_formItem" label="网关密码：" prop="password" :label-width="formLabelWidth">
              <el-input v-model="form.password" autocomplete="off" :disabled="disabled"></el-input>
            </el-form-item>
          
          </div>
        </div>
        <p class="fz14 mt20">客户信息</p>
        <div class=" mt10 boxDashed flex center-row" >
          
          <div class="item_ flex center-row">
            <el-form-item class="_formItem" label="联系人：" :label-width="formLabelWidth">
                <el-input v-model="form.userName" autocomplete="off" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item class="_formItem" label="联系电话：" :label-width="formLabelWidth">
                <el-input v-model="form.userPhone" type="number" autocomplete="off" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item class="_formItem" label="客户名称：" :label-width="formLabelWidth">
                <el-input v-model="form.customerName" autocomplete="off" :disabled="disabled"></el-input>
              </el-form-item>
              <el-form-item class="_formItem" label="出厂日期：" :label-width="formLabelWidth">
                <el-date-picker v-model="form.productionTime"  value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd" autocomplete="off" type="date" placeholder="选择日期"
                  :disabled="disabled">
                </el-date-picker>
              </el-form-item>
              <el-form-item class="_formItem" label="质保到期：" :label-width="formLabelWidth">
                <el-date-picker v-model="form.expirationTime" value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd" autocomplete="off" type="date" placeholder="选择日期"
                  :disabled="disabled">
                </el-date-picker>
              </el-form-item>
           </div>
        </div>
        <p class="fz14 mt20">位置信息</p>
        <div class="mt10 boxDashed" >
          <div class="item_ flex center-row">
          <el-form-item class="_formItem" label="省份" :label-width="formLabelWidth">
            <el-input v-model="form.province" autocomplete="off" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item class="_formItem" label="城市" :label-width="formLabelWidth">
            <el-input v-model="form.city" autocomplete="off" :disabled="disabled"></el-input>
          </el-form-item>
          <el-form-item class="_formItem" label="安装时间" :label-width="formLabelWidth">
            <el-date-picker v-model="form.installTime" value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd" autocomplete="off" type="date" placeholder="选择日期"
              :disabled="disabled">
            </el-date-picker>
          </el-form-item>
          <el-form-item class="_formItem" label="经度" :label-width="formLabelWidth">
            <el-input v-model="form.location.lon" v-if="DialogVisible" autocomplete="off" :disabled="disabledLocation">
            </el-input>
          </el-form-item>
          <el-form-item class="_formItem" label="纬度" :label-width="formLabelWidth">
            <el-input v-model="form.location.lat" v-if="DialogVisible" autocomplete="off" :disabled="disabledLocation">
            </el-input>
          </el-form-item>
          <el-form-item class="_formItem" label="详细位置" :label-width="formLabelWidth">
            <el-input v-model="form.address" autocomplete="off" :disabled="disabled"></el-input>
          </el-form-item>
          </div>
        </div>
       
        <div class="item_ flex between mt10" style="height: 50px;" v-if="!disabled">
          <el-form-item class="_formItem txtl">
            <!-- <span style="font-size:12px;color:red;">（选取点后，经度、纬度、省份、城市会被自动添上）</span> -->
            <el-button-group>
              <!-- 1、地图上选点(chose) 2、关键词搜索(search) -->
              <el-button size="small" :type="pointChoseType=='chose'?'primary':'info'" @click="mapselectpoint">地图上选点
              </el-button>
              <el-button size="small" :type="pointChoseType=='search'?'primary':'info'" @click="mapkeyword">关键词搜索
              </el-button>
            </el-button-group>
          </el-form-item>
          <el-form-item  v-show="pointChoseType == 'search'" label="地点"
            :label-width="formLabelWidth">
            <el-input v-model="mapsearch" class="searchStation" placeholder="请输入要搜索的地点"
              @keyup.enter.native="mapKeyWord()">
              <el-button slot="append" icon="el-icon-search" @click="mapKeyWord"></el-button>
            </el-input>
          </el-form-item>
        </div>
        <div class="item_">
          <!-- 地图 -->
          <div id="StationMap"></div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer flex row vertical-center" v-if="!disabled">
        <el-button @click="closedialog" size="small" class="mr40">取 消</el-button>
        <el-button type="primary" size="small" @click="dialogType=='添加设备'?addBtn():editBtn()">确 定
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加或编辑弹出对话框 -->
    <el-dialog title="提示" :visible.sync="deleteDialogVisible" width="30%" center>
      <div class="flex center">确认删除该设备？</div>
      <div slot="footer" class="dialog-footer flex row vertical-center">
        <el-button @click="deleteDialogVisible = false" class="mr40">取 消</el-button>
        <el-button type="primary" @click="deleteBtn()">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导入EXCEL表格 -->
    <el-dialog title="导入EXCEL" :visible.sync="excelDialogVisible" width='40%' center>
      <el-row>
        <excelupdate @childByValue='childByValue' />
        <div>
          <el-button size="small" type="primary" @click="UpData" style="margin:25px 0 15px 0">点击导入</el-button>
          <p class="login-tips">说明: 导入文件类型必须为excel格式，你可以先点击 <a
              href="https://weikente-manage.oss-cn-hangzhou.aliyuncs.com/%E5%A8%81%E8%82%AF%E7%89%B9-%E5%B7%A5%E5%85%B7-%E6%A8%A1%E6%9D%BF.xlsx">下载模板</a>。
          </p>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
// import BMap from 'BMap'
import { MESSAGE } from '@/util/elementHandle.js'
import BaiduMap from 'vue-baidu-map'
import { mapGetters } from 'vuex';
import {dictType} from '@/api/deviceOverview/alarm'
import dotedLineBox from '@/components/power/dottedLineBox';
import { getList, addObj, editObj, deleteObj, api,modelList } from '@/api/deviceOverview/powerStation';
import { queryDealerList } from '@/api/deviceOverview/common';
import { importExcel } from '@/api/deviceOverview/device';
import excelupdate from '@/components/excelupdate'
const moment = require('moment');
export default {
  name: 'deviceManage',
  components: {
    dotedLineBox,excelupdate
  },
  data() {
    return {
      isclose:true,
      mapsearch: '',
      disabled: '',
      disabledLocation: '', // 能否编辑经纬度
      nowTimeStr: "", // 实时日期时间
      deleteStationId: '',
      dialogType: '',  // 添加或编辑对话框显示类型
      installDate: '', // 安装时间
      ifAdd: '', // 添加或编辑表单类型
      DialogVisible: false, // 添加或编辑表单显示
      deleteDialogVisible: false,  //删除确认显示
      excelDialogVisible: false, // excel表导入弹窗
      excelData: [],   // excel表格数据
      rules:{
          gatewayName: [
            { required: true, message: '请输入网关名称', trigger: 'blur' }
          ],
          sn: [
            { required: true, message: '请输入网关sn', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入网关密码', trigger: 'blur' }
          ],
          deviceModel: [
            { required: true, message: '请选择设备类型', trigger: 'change' }
          ],
          deviceNo: [
            { required: true, message: '请输入设备出厂编号', trigger: 'blur' }
          ],
          sawModel: [
            { required: true, message: '请输入设备型号', trigger: 'blur' }
          ],
      },
      form: {          // 添加或编辑 表单
        installTime: '',
        address: '', //详细位置
        city: '', //城市
        installCapacity: '', //装机容量
        location: {
          lat: null,
          lon: null
        }, //位置
        deviceNo: '', //设备出厂编号
        sawModel:'', //设备型号
        province: '', //省份
        gatewayName: '', //网关名称
        sn: '', //sn
        password: '', //网关密码
        type: '', // 设备类型
        userName: '', //联系人
        userPhone: '', // 联系电话
        customerName: '', // 客户名称
        productionTime: '', //出厂日期
        expirationTime: '',  // 质保到期
        gatewayId:''
      },
      typeList: [],
      formLabelWidth: '110px',
      pointChoseType: 'chose', // 哪种选点方式---1、地图上选点(chose) 2、关键词搜索(search)
      keyWordObj: null,         // 关键词检索变量
      map: null,             // 地图实例
      prePoint: {},         // 地图搜索关键字储存上一个点坐标
      query: {
        address: '',
        name: '',
        pageIndex: 1,
        pageSize: 10
      },
      tableData: [],
      multipleSelection: [],
      delList: [],
      editVisible: false,
      pageTotal: 0,
      form: {},
      idx: -1,
      id: -1,
      gw_add:true,
      gw_edit:true,
      gw_del:true,
      oneTitle: '网关信息',
      deviceList: [],
      gatewayList: [],
      deviceStatus: '',
      gatewayStatus: '',
      dealerOptions: [],   // 经销商列表
      dealer: '',
      deviceNoInput: '',  //设备出厂编号
      sawModelInput: ''  //设备型号
    };
  },
  mounted() {
  },
  created() {
    this.getPage();
    // this.queryList()
    this.queryDeviceList()
    // this.getDealerList()
    console.log(this.permissions['gw_add'],'----permissions');
    // 显示实时日期时间
    this.nowTimeStr = moment().format("YYYY-MM-DD");

    // this.permissions['gw_add'] && (this.gw_add = this.permissions['gw_add'])
    // this.permissions['gw_edit'] && (this.gw_edit = this.permissions['gw_edit'])
    // this.permissions['gw_del'] && (this.gw_del = this.permissions['gw_del'])
  },
  methods: {
    beforclose(){
     
      this.$refs.form.resetFields()
      this.DialogVisible = false
    },
    closedialog(){
    
      this.$refs.form.resetFields()
      this.DialogVisible = false
    },
     /* 经销商列表
      */
    getDealerList () {
        queryDealerList().then(res=>{
            if (res.data.code === 200) {
              if (!res.data.data) {
                        return
                    }
                this.dealerOptions = res.data.data
                this.dealerOptions.unshift({id:'',realName:"全部"})
            } else {
                MESSAGE({
                    text: res.data.msg,
                    type: 'error'
                });
            }
        })
    },
    
    queryList () {
      dictType('device_state').then(res=>{
        if (res.data.code === 200) {
            this.deviceList = []
            this.deviceList = res.data.data;
            this.deviceList.unshift({description:"设备状态",dictValue:"全部",dictKey:""})
        } else {
            this.$message.error(res.data.msg);
            return;
        }
      })
    },
    queryDeviceList () {
      modelList().then(res=>{
        console.log(res, 'res---')
        if (res.data.code === 200) {
          this.typeList = res.data.data
        } else {
          MESSAGE({
              text: res.data.msg,
              type: 'error'
          })
        }
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.query.pageSize = val
      this.getPage()
    },
    handlePageChange(val) {
      this.query.pageIndex = val
      this.getPage()
    },
    // 操作相关
    // 添加
    addHandle() {
      this.dialogType = '添加设备'
      this.disabled = false              // 启用其余输入
      this.DialogVisible = true         // 显示表单
      this.disabledLocation = false      // 启用编辑经纬度输入
      this.form = {          // 添加或编辑 表单
        address: '', //详细位置
        city: '', //城市
        installCapacity: '', //装机容量
        location: {
          lat: null,
          lon: null
        }, //位置
        deviceNo: '', 
        sawModel:'', 
        province: '', //省份
        gatewayName: '', //网关名称
        sn: '', //sn
        password: '', //网关密码
        deviceModel: '', // 设备类型
        userName: '', //联系人
        userPhone: '', // 联系电话
        customerName: '', // 客户名称
        productionTime: this.nowTimeStr, //出厂日期
        expirationTime: this.nowTimeStr,  // 质保到期
        installTime: this.nowTimeStr //安装时间
      },
        this.keyWordObj = null,
        this.mapselectpoint()
    },
    // 查看
    viewHandle(row) {
      this.dialogType = '查看设备'
      this.disabled = true              // 禁用其余输入
      this.DialogVisible = true         // 显示表单
      this.disabledLocation = true      // 禁用编辑经纬度输入
      this.form = row
      this.form.location = JSON.parse(row.location)
      this.form.deviceModel = row.deviceModel+''
      this.mapselectpoint()
    },
    // 编辑
    editHandle(row) {
      this.dialogType = '编辑设备'
      this.disabled = false              // 启用其余输入
      this.DialogVisible = true         // 显示表单
      this.disabledLocation = true      // 禁用编辑经纬度输入
      this.form = row
      this.form.location = JSON.parse(row.location)
      this.form.deviceModel = row.deviceModel+''
      this.mapselectpoint()
    },
    // 删除
    deleteHandle(row) {
      this.deleteDialogVisible = true
      this.deleteStationId = row.gatewayId
    },
    // 地图初始化
    mapinit() {
      // 创建地图实例
      this.map = new BMap.Map('StationMap')
      // 设置中心点和缩放比例
      // this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11)
      this.prePoint = this.form.location
      if (this.form.location.lon == null || this.form.location.lon == '') {
        this.map.centerAndZoom('杭州', 11)
      } else {
        this.map.centerAndZoom(new BMap.Point(this.form.location.lon, this.form.location.lat), 11)
        var point = new BMap.Point(this.form.location.lon, this.form.location.lat);
        var myIcon = new BMap.Icon(require('@/assets/img/map_icon.png'), new BMap.Size(47, 49))
        var marker = new BMap.Marker(point, { icon: myIcon })  // 创建标注
        this.map.addOverlay(marker) // 将标注添加到地图中
      }

      // 修改地图主题样式
      this.map.setMapStyle({
        style: this.currentMayStyle
      })
      // 开启鼠标滚轮缩放
      this.map.enableScrollWheelZoom(true)
    },
    // 选择-地图上选点
    mapselectpoint() {
      // 修改选点方式
      this.pointChoseType = 'chose' // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图
      this.map = null
      // 清除 地点关键词
      this.form.locationKeyWord = '' // 地点关键词
      // 设置地图
      this.$nextTick(function () {

        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit()
        // 添加点击地图监听事件---点击地图后添加标注点
        if (this.dialogType != '查看设备') {
          this.map.addEventListener('click', function (e) {
            // console.log(e)
            // 清除标注点
            this.map.clearOverlays()
            // 添加标注点
            var point = new BMap.Point(e.point.lng, e.point.lat) // 创建点
            var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49))
            var marker = new BMap.Marker(point, { icon: myIconOn })  // 创建标注
            // var marker = new BMap.Marker(point)  // 创建标注
            this.map.addOverlay(marker) // 将标注添加到地图中
            // 修改form表单内容
            // 设备坐标
            this.form.location = {
              'lat': e.point.lat.toFixed(6),
              'lon': e.point.lng.toFixed(6)
            }
            var geoc = new BMap.Geocoder() // 用于获取用户的地址解析
            // 地址解析
            geoc.getLocation(e.point, function (rs) {
              var addComp = rs.addressComponents
              // 设备所在省份
              this.form.province = addComp.province
              // 设备所在城市
              this.form.city = addComp.city
            }.bind(this))
          }.bind(this))
        }
      }.bind(this))
    },
    // 选择-关键词搜索
    mapkeyword() {
      console.log(1)
      // 修改选点方式
      // debugger
      this.pointChoseType = 'search' // 1、地图上选点(chose) 2、关键词搜索(search)
      // 清除地图
      this.map = null
      // 清除 地点关键词
      this.form.locationKeyWord = '' // 地点关键词
      // 设置地图
      this.$nextTick(function () {
        // 百度地图是必须让它在页面加载完成后显示（生命周期mounted），但是由于element的对话框（el-dialog）是基于v-if这个功能。所以，应该在dom加载完后再初始化地图
        // 地图初始化
        this.mapinit()

        var _this = this
        // 关键词检索
        var gjcOptions = {
          // 结果呈现设置
          renderOptions: { map: this.map },
          // // 标注添加完成后的回调函数
          // onMarkersSet: function () {
          //   console.log('onMarkersSet')
          // },
          // 标注气泡内容创建后的回调函数---点击不同气泡会触发
          onInfoHtmlSet: function (res) {
           
            // 修改form表单内容
            // 设备坐标
            _this.form.location = {
              'lat': res.point.lat.toFixed(6),
              'lon': res.point.lng.toFixed(6)
            }
            // 设备所在省份
            _this.form.province = res.province
            // 设备所在城市
            _this.form.city = res.city
          }

          // // 结果列表添加完成后的回调函数
          // onResultsHtmlSet: function () {
          //   console.log('onResultsHtmlSet')
          // },
          // // 检索完成后的回调函数
          // onSearchComplete: function (results) {
          //   console.log(results)
          // }
        }
        // console.log(gjcOptions)
        this.keyWordObj = new BMap.LocalSearch(this.map, gjcOptions) // 用于位置检索、周边检索和范围检索。
        var allOverlay = this.map.getOverlays();
        console.log(allOverlay)
        // this.keyWordObj.search("景点")
        // 添加点击地图监听事件---点击地图后添加标注点
        this.map.addEventListener('click', function (e) {
          // console.log(e)
          // console.log(this.prePoint)
          // 清除标注点
          // this.map.clearOverlays(marker)
          var allOverlay = this.map.getOverlays();
          // console.log(allOverlay)
          // console.log(this.prePoint)
          for (var i = 0; i < allOverlay.length; i++) {
            if (allOverlay[i].point && (allOverlay[i].point.lng == this.prePoint.lon && allOverlay[i].point.lat == this.prePoint.lat)) {
              this.map.removeOverlay(allOverlay[i]);
              // return false;
            }
          }
          this.mapsearch = ''
          // 添加标注点
          var point = new BMap.Point(e.point.lng, e.point.lat) // 创建点
          var myIconOn = new BMap.Icon(require("@/assets/img/map_icon.png"), new BMap.Size(47, 49))
          var marker = new BMap.Marker(point, { icon: myIconOn })  // 创建标注
          // var marker = new BMap.Marker(point)  // 创建标注
          this.map.addOverlay(marker) // 将标注添加到地图中
          // 修改form表单内容
          // 设备坐标
          this.form.location = {
            'lat': e.point.lat.toFixed(6),
            'lon': e.point.lng.toFixed(6)
          }
          this.prePoint = {
            'lat': e.point.lat,
            'lon': e.point.lng
          }
          var geoc = new BMap.Geocoder() // 用于获取用户的地址解析
          // 地址解析
          geoc.getLocation(e.point, function (rs) {
            var addComp = rs.addressComponents
            // 设备所在省份
            this.form.province = addComp.province
            // 设备所在城市
            this.form.city = addComp.city
          }.bind(this))
        }.bind(this))
      }.bind(this))
    },

    // 点击地点的搜索---关键词检索
    mapKeyWord() {
      console.log(2)
      this.keyWordObj.search(this.mapsearch)
    },
    search () {
      this.query.pageIndex = 1
      this.getPage()
    },
    // api相关
    // 查询列表数据
    getPage() {
      let obj ={current: this.query.pageIndex, size: this.query.pageSize, gatewayName: this.query.name,onlineFlag: this.gatewayStatus, deviceState: this.deviceStatus, deviceNo: this.deviceNoInput,sawModel: this.sawModelInput}
      this.dealer && (obj.dealerId = this.dealer)

      getList(obj).then(response => {
        console.log(response);
        const { data } = response.data
        // debugger
        if (response.data.code === 200) {
          data.records.map((item, index) => {
            // item.location = JSON.parse(item.location)
            item.id = index + 1
          })
          this.tableData =  data.records
        }
        this.pageTotal = data.total
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 添加确认
    addBtn() {
     
        this.$refs['form'].validate((valid) => {
        console.log(valid)
        if (valid) {
          const {gatewayName,deviceModel,sn,password,province,city, deviceNo, 
            sawModel, address,userName,userPhone,customerName,installTime,productionTime,expirationTime} = this.form
         let param = {
            gatewayName,
            deviceModel,
            sn,
            password,
            province,
            deviceNo, 
            sawModel, 
            city,
            address,userName,userPhone,customerName,installTime,productionTime,expirationTime,
            location:JSON.stringify(this.form.location)
          }
          console.log(param)
          addObj(param).then(response => {
            if (response.data.code === 200) {
              MESSAGE({
                text: '添加成功',
                type: 'success'
              })
              this.DialogVisible = false
              this.query.pageIndex = 1
              console.log(response);
              this.getPage()
            } else {
              MESSAGE({
                text: '添加失败',
                type: 'error'
              })
            }
          })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          return false;
        }
      });
      
      
      
    },
    // 编辑确认
    editBtn() {
     
        this.$refs['form'].validate((valid) => {
        console.log(valid)
        if (valid) {
        const {gatewayName,deviceModel,sn,password, deviceNo, 
            sawModel, province,city,address,userName,userPhone,customerName,installTime,productionTime,expirationTime,gatewayId} = this.form
        let param = {
            gatewayId,
            gatewayName,
            deviceModel, deviceNo, 
            sawModel, 
            sn,
            password,
            province,
            city,
            userName,
            address,userPhone,customerName,installTime,productionTime,expirationTime,
            location:JSON.stringify(this.form.location)
          }
          console.log(param)
          editObj(param).then(response => {
            if (response.data.code === 200) {
              MESSAGE({
                text: '修改成功',
                type: 'success'
              })
              this.DialogVisible = false
              console.log(response);
              this.getPage()
            } else {
              MESSAGE({
                text: '修改失败',
                type: 'error'
              })
            }
          })
            .catch(function (error) {
              console.log(error);
            });
        } else {
          return false;
        }
      })
      
      
    },
    // 删除确认
    deleteBtn() {
      let param = {
        id: this.deleteStationId
      }
      deleteObj(param).then(response => {
        if (response.data.code === 200) {
          MESSAGE({
            text: '删除成功',
            type: 'success'
          })
          this.deleteDialogVisible = false
          // console.log(response);
          this.getPage()
        } else {
          MESSAGE({
            text: '删除失败',
            type: 'error'
          })
        }
      })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 导入EXCEL相关
    addexcel() {
      this.excelDialogVisible = true
    },
    // 处理excel数据
    childByValue(val) {
      console.log(val)
      let arr = []
      val.map((item, index) => {
        let obj = {}
        obj.gatewayName = JSON.parse(JSON.stringify(item))["设备名称"]
        obj.deviceModel = JSON.parse(JSON.stringify(item))["设备型号"]
        obj.sn = JSON.parse(JSON.stringify(item))["SN"]
        obj.password = JSON.parse(JSON.stringify(item))["密码"]
        obj.userName = JSON.parse(JSON.stringify(item))["联系人"]
        obj.userPhone = JSON.parse(JSON.stringify(item))["联系电话"]
        obj.customerName = JSON.parse(JSON.stringify(item))["供应商名称"]
        obj.productionTime = JSON.parse(JSON.stringify(item))["采购日期"]
        obj.expirationTime = JSON.parse(JSON.stringify(item))["质保日期"]
        obj.installTime = JSON.parse(JSON.stringify(item))["安装时间"]
        obj.province = JSON.parse(JSON.stringify(item))["省份"]
        obj.city = JSON.parse(JSON.stringify(item))["地市"]
        obj.address = JSON.parse(JSON.stringify(item))["详细地址"]
        arr[index] = obj
      })
      this.excelData = arr
      console.log(this.excelData)
    },
    // 上传excel
    UpData() {
      importExcel(this.excelData).then(res => {
        if (res.code === '0') {
          this.close(0)
          this.$message({
            message: '上传成功',
            type: 'success'
          });
        } else {
          this.$message.error('上传失败');
        }
      })
    },
  },
  computed: {
    ...mapGetters(['permissions'])
  }
};
</script>

<style  lang='scss'>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.red {
    color: #ff0000;
}

</style>
<style lang='scss' scope>
.containerManage{
  overflow-y: auto;
  box-sizing: border-box;
  width: calc(100% - 20px);
}
.boxDashed {
   border: 1px dashed #31416F;padding: 20px 10px 0px;border-radius: 10px;
}
.status{
    width: 10px;
    height: 10px;
   
    display: inline-block;
    border-radius: 50%;;
    }
    .status0{
     background: #ccc;
    }
    .status1{
       background: chartreuse;
    }
    .status3{
      background: #259b24;
    }
    .status4{
      background: #ff9800
    }
.item_ {
    #StationMap {
        width: 100%;
        height: 250px;
        .BMap_cpyCtrl {
            display: none;
        }
        .anchorBL {
            display: none;
        }
    }
    
    ._formItem {
        width: 31%;padding-right:2%;
        float: left;
        margin-bottom: 20px;
        .el-form-item__label{
          color: #31416F;
        }
        .searchStation {
            .el-input__inner {
                font-size: 14px;
                padding: 0 5px;
            }
            .el-input-group__append {
                padding: 0 12px;
            }
        }
        .el-input {
            width: 100%;
            .el-input__inner {
                font-size: 14px;
            }
        }
    }
}

</style>
